<template>
    <div id="users-settings">
        <v-card id="locale-card" class="main_component_card">
            <v-card-title>
              <span class="main_card_title">{{ $i18n.t('pages.security.users.all_users')}}</span>
            </v-card-title>
            <v-card-text>
                <v-data-table
                :headers="user_table_headers"
                :items="users"
                :footer-props="{
                itemsPerPageText: $i18n.t('table_footers.rows_per_page'),
                itemsPerPageOptions: [5, 10, 20],
                }"
                >
                  <template #footer.page-text="props">
                  {{ $i18n.t('table_footers.some_rows_of_all', {some: `${props.pageStart}-${props.pageStop}`, all: `${props.itemsLength}`})}}
                  </template>
                  <!--
                  <template v-slot="items" slot-scope="props">
                    <td class="text-xs-right">{{props.item.username}}</td>
                    <td class="text-xs-right">{{role_name(props.item.role_id)}}</td>
                    <td class="text-xs-right">
                       <div v-if="props.item.created_by === 'system'"  style="display: flex; justify-content: flex-end; padding-right: 18px;">
                         <v-btn icon @click="open_editor(props.item)"><v-icon>$icon_edit</v-icon></v-btn>
                       </div>
                       <div v-else style="display: flex; justify-content: flex-end">
                         <v-btn icon @click="open_editor(props.item)"><v-icon>$icon_edit</v-icon></v-btn>
                         <v-btn icon  @click="delete_user(props.item)"><v-icon>$icon_trash</v-icon></v-btn>
                       </div>
                     </td>
                  </template>
                  -->

                  <template v-slot:item="{item, index}">
                     <tr :id="index">
                       <td>{{ item.username }}</td>
                       <td>{{ role_name(item.role_id) }}</td>
                       <!-- <td>{{ item.role_id | role_id_to_role_name(item.role_id, roles) }}</td> -->
                       <td>
                         <div v-if="item.created_by === 'system'"  style="display: flex; justify-content: flex-end; padding-right: 18px;">
                           <v-btn icon @click="open_editor(item)"><v-icon>$icon_edit</v-icon></v-btn>
                         </div>
                         <div v-else style="display: flex; justify-content: flex-end">
                           <v-btn icon @click="open_editor(item)"><v-icon>$icon_edit</v-icon></v-btn>
                           <v-btn icon  @click="delete_user(item)"><v-icon>$icon_trash</v-icon></v-btn>
                         </div>
                       </td>

                     </tr>
                  </template>

                </v-data-table>
            </v-card-text>
        </v-card>

        <v-dialog eager v-model="user_edit_dialog" max-width="420px">
            <v-card style="border-radius: 8px" elevation="0">
                <v-card-title>
                    <span>{{form_title}}</span>
                </v-card-title>
                <v-card-text style="padding: 0 15px 30px">
                  <v-form class="edit_card_container" v-model="user_form_valid" ref="user_validation">
                    <v-subheader class="subheader">{{ $i18n.t('pages.security.users.dialog.username') }}</v-subheader>
                    <v-text-field
                        class="rounded_8px height_56px"
                        outlined
                        :placeholder="$i18n.t('pages.security.users.dialog.username')"
                        v-model="edited_user.username"
                        required
                        :rules="validation_rules.username"
                    />
                    <v-subheader class="subheader" style="margin-top: 22px;">{{ $i18n.t('pages.security.users.dialog.role') }}</v-subheader>
                    <v-autocomplete
                      class="rounded_8px height_56px"
                      v-model="edited_user.role_id"
                      :items="roles"
                      item-text="name"
                      item-value="_id"
                      :disabled="edited_user.created_by === 'system'"
                      :placeholder="$i18n.t('pages.security.users.dialog.role')"
                      :rules="validation_rules.role"
                      outlined
                      required
                    />

                    <v-checkbox
                        style="padding: 0"
                        v-if="edited_user_index > -1"
                        v-model="want_to_change_password"
                        :label="$i18n.t('pages.security.admin.dialog.change_password')"
                    />
                    <div v-if="want_to_change_password">
                      <v-subheader class="subheader">{{ $i18n.t('pages.security.users.dialog.old_password') }}</v-subheader>
                      <v-text-field
                        class="rounded_8px height_56px"
                        outlined
                        :placeholder="$i18n.t('pages.security.users.dialog.password_again')"
                        v-model="edited_user.old_password"
                        :append-icon="show_old_user_password ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="show_old_user_password = !show_old_user_password"
                        :type="show_old_user_password ? 'text' : 'password'"
                        required
                        :rules="validation_rules.password"
                      />
                      <v-subheader class="subheader margin-t">{{ $i18n.t('pages.security.users.dialog.new_password') }}</v-subheader>
                      <v-text-field
                        class="rounded_8px height_56px"
                        outlined
                        :placeholder="$i18n.t('pages.security.users.dialog.password')"
                        v-model="edited_user.password"
                        :append-icon="show_user_password ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="show_user_password = !show_user_password"
                        :type="show_user_password ? 'text' : 'password'"
                        required
                        :rules="validation_rules.password"
                      />
                      <v-subheader class="subheader" style="margin-top: 22px;">{{ $i18n.t('pages.security.users.dialog.new_password_again') }}</v-subheader>
                      <v-text-field
                        class="rounded_8px height_56px"
                        outlined
                        :placeholder="$i18n.t('pages.security.users.dialog.password_again')"
                        v-model="edited_user.repeated_password"
                        :append-icon="show_user_password_repeated ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="show_user_password_repeated = !show_user_password_repeated"
                        :type="show_user_password_repeated ? 'text' : 'password'"
                        required
                        :rules="validation_rules.password"
                      />
                    </div>
                    <div v-if="edited_user_index <= -1">
                      <v-subheader class="subheader margin-t">{{ $i18n.t('pages.security.users.dialog.password') }}</v-subheader>
                      <v-text-field
                        class="rounded_8px height_56px"
                        outlined
                        :placeholder="$i18n.t('pages.security.users.dialog.password')"
                        v-model="edited_user.password"
                        :append-icon="show_user_password ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="show_user_password = !show_user_password"
                        :type="show_user_password ? 'text' : 'password'"
                        required
                        :rules="validation_rules.password"
                      />
                      <v-subheader class="subheader" style="margin-top: 22px;">{{ $i18n.t('pages.security.users.dialog.password_again') }}</v-subheader>
                      <v-text-field
                        class="rounded_8px height_56px"
                        outlined
                        :placeholder="$i18n.t('pages.security.users.dialog.password_again')"
                        v-model="edited_user.repeated_password"
                        :append-icon="show_user_password_repeated ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="show_user_password_repeated = !show_user_password_repeated"
                        :type="show_user_password_repeated ? 'text' : 'password'"
                        required
                        :rules="validation_rules.password"
                      />
                    </div>
                  </v-form>
                  <div style="padding: 20px 15px 0 15px; display: flex; justify-content: space-between">
                    <v-btn
                      class=" white--text"
                      height="42"
                      color="#DBEAF1"
                      elevation="0"
                      style="width: 170px"
                      @click="user_edit_dialog = false"
                    >
                      <span style="color: #207EA9" class="button-font">{{ $i18n.t('general.close') }}</span>
                    </v-btn>
                    <v-btn
                        class="width48 white--text"
                        style="width: 170px"
                        height="42"
                        elevation="0"
                        color="#207ea9"
                        @click="save_user"
                    >
                      <span class="button-font">{{ $i18n.t('general.save') }}</span>
                    </v-btn>
                </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

import {mapActions} from "vuex";
import {i18n} from "@/i18n";

import {EventBus} from "@/bus";
import {common_funcs} from "@/mixins/common";
import {custom_table_filters} from "@/mixins/custom_table_filters";

export default {
    name: "UsersSettings",
    props: ['on', 'attrs', 'users', 'roles'],
    mixins: [common_funcs, custom_table_filters],
    data: function () {
      EventBus.$on('users_event', this.on_users_event)
      // this.fetch_data()
      return {

        user_form_valid: true,
        user_edit_dialog: false,
        validation_rules: {
          username: [
            v => !!v || i18n.t('validation.this_field_is_required'),
            v => (!v || v.length >= 5) || i18n.t('validation.username_too_short', {length: 5})
          ],
          password: [
            v => !!v || i18n.t('validation.this_field_is_required'),
            v => (!v || v.length >= 5) || i18n.t('validation.password_too_short', {length: 5})
          ],
          role: [
              v => !!v || i18n.t('validation.this_field_is_required'),
          ]
        },
        show_old_user_password: false,
        show_user_password: false,
        show_user_password_repeated: false,
        edited_user_index: -1,
        want_to_change_password: false,
        default_user: {
          _id: '',
          username: '',
          role_id: '',
          old_password: '',
          password: '',
          repeated_password: '',
          created_by: 'admin'
        },
        edited_user: {
          _id: '',
          username: '',
          role_id: '',
          old_password: '',
          password: '',
          repeated_password: '',
          created_by: 'admin'
        },
        user_table_headers: [
          {text: i18n.t('pages.security.users.table.headers.username'), align: 'start', value: 'username'},
          {text: i18n.t('pages.security.users.table.headers.role'), value: 'role',
          },
          {text: i18n.t('pages.security.users.table.headers.actions'), align: 'end', value: 'actions', sortable: false}
        ],
        alert: false,
        alert_text: '',
      }
    },
    methods: {
      on_users_event: function (params) {
        let event_name = params.event_name
        if (event_name === 'add_user') {
          this.open_editor(null)
        }
      },
      /*
      users_table_custom_sort: function (items, index, isDesc) {
        items.sort((a, b) => {
          if (index === 'username') {
            if (!isDesc) {
              return a[index] < b[index] ? -1 : 1;
            } else {
               return b[index] < a[index] ? -1 : 1;
            }
          }
          else if (index === 'role') {
            if (!isDesc) {
              return this.compare_roles(a.role_id, b.role_id);
            } else {
              return this.compare_roles(b.role_id, a.role_id);
            }
          }
        })
        return item
      },
       */
      compare_roles: function (a_role_id, b_role_id) {
        return this.role_name(a_role_id) < this.role_name(b_role_id) ? -1 : 1
      },
      open_editor: function (user) {
        this.user_edit_dialog = true
        if (!user) {
          this.edited_user = Object.assign({}, this.default_user)
          return
        }
        this.edited_user = Object.assign({}, user)
        this.edited_user_index = this.users.indexOf(user)
      },
      close_editor: function () {
        this.user_form_valid = true
        this.want_to_change_password = false
        this.$nextTick(() => {
          this.edited_user = Object.assign({}, this.default_user)
          this.edited_user_index = -1
        })
      },
      delete_user: function(user) {
        let data = {'user_id': user._id}
        confirm(i18n.t('submissions.delete_user', {username: user.username})) &&
        this.$http({url: this.$http_hostname + '/users/delete_user_by_id', data: data, method: 'DELETE'})
        .then(() => {
          let user_index = this.users.indexOf(user)
          this.users.splice(user_index, 1)
        })
        .catch(error => {
          this.show_error_message(error)
        })
      },
      save_user: function () {
        if (!this.$refs.user_validation.validate()) return
        if (this.edited_user.password !== this.edited_user.repeated_password) {
          this.setSnackbar({
            text: i18n.t('notifications.security.passwords_dont_match')
          })
          return 
        }
        let _edited_user = this.edited_user
        let user_index = this.edited_user_index
        let data = {'user': _edited_user}
        if (this.user_form_valid) {
          if (this.edited_user_index > -1) {
            this.$http({url: this.$http_hostname + '/users/edit_user', data: data, method: 'POST'})
            .then( () => {
              Object.assign(this.users[user_index], _edited_user)
              // this.users.push(_edited_user)
              this.setSnackbar({
                text: i18n.t('notifications.security.user_changed', {username: _edited_user.username})
              })
            })
            .catch((error) => {
              this.show_error_message(error)
            })
          } else {
            this.$http({url: this.$http_hostname + '/users/create_user', data: data, method: 'POST'})
            .then( (resp) => {
              _edited_user._id = resp.data['new_user_id']
              _edited_user.password = _edited_user.repeated_password = ''
              this.users.push(_edited_user)
            })
            .catch((error) => {
              this.show_error_message(error)
            })
          }
          this.user_edit_dialog = false
        }
      },
      role_name: function (role_id) {
        return this.roles.find(role => role._id['$oid'] === role_id['$oid']).name
      },
      ...mapActions(['setSnackbar'])
    },
  computed: {
      form_title: function () {
        let text_add_user = i18n.t('pages.security.users.dialog.add_user')
        let text_edit_user = i18n.t('pages.security.users.dialog.edit_user')
        return this.edited_user_index === -1 ? text_add_user : text_edit_user
      },
  },
  watch: {
      user_edit_dialog (val) {
        this.$refs.user_validation.resetValidation()
        !val && this.close_editor()
      }
  },
}
</script>

<style scoped>
#locale-card {
  background: #FFFFFF;
  box-shadow: 0 3px 2px rgba(138, 138, 138, 0.15);
  border-radius: 8px;
}
</style>